import { render, staticRenderFns } from "./EqifyRulePersonHasLicense.vue?vue&type=template&id=3a73c032&scoped=true"
import script from "./EqifyRulePersonHasLicense.vue?vue&type=script&lang=ts"
export * from "./EqifyRulePersonHasLicense.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a73c032",
  null
  
)

export default component.exports